import { useState, useEffect } from 'react';

import { SelectOption } from '~/shared/utils/types';

interface UseFilterStateProps {
  open: boolean;
  appliedClusterNameFilters: SelectOption[];
  appliedInstanceFilters: SelectOption[];
  appliedVolumeIdFilters: SelectOption[];
  appliedVolumeTagFilters: SelectOption[];
  appliedAutoscaleState: string[];
}

export function useFilterState({
  open,
  appliedClusterNameFilters,
  appliedInstanceFilters,
  appliedVolumeIdFilters,
  appliedVolumeTagFilters,
  appliedAutoscaleState,
}: UseFilterStateProps) {
  const [pendingAutoscaleState, setPendingAutoscaleState] =
    useState<string[]>(appliedAutoscaleState);
  const [pendingClusterNameFilters, setPendingClusterNameFilters] =
    useState<SelectOption[]>(appliedClusterNameFilters);
  const [pendingVolumeIdFilters, setPendingVolumeIdFilters] =
    useState<SelectOption[]>(appliedVolumeIdFilters);
  const [pendingVolumeTagFilters, setPendingVolumeTagFilters] =
    useState<SelectOption[]>(appliedVolumeTagFilters);
  const [pendingInstanceFilters, setPendingInstanceFilters] =
    useState<SelectOption[]>(appliedInstanceFilters);
  const [lastSyncedOpen, setLastSyncedOpen] = useState(open);

  // Sync pending state with applied filters only when the panel opens (not while editing)
  useEffect(() => {
    // Only sync when the panel transitions from closed to open
    if (open && !lastSyncedOpen) {
      setPendingAutoscaleState(appliedAutoscaleState);
      setPendingClusterNameFilters(appliedClusterNameFilters);
      setPendingVolumeIdFilters(appliedVolumeIdFilters);
      setPendingVolumeTagFilters(appliedVolumeTagFilters);
      setPendingInstanceFilters(appliedInstanceFilters);
    }
    setLastSyncedOpen(open);
  }, [
    open,
    lastSyncedOpen,
    appliedAutoscaleState,
    appliedClusterNameFilters,
    appliedVolumeIdFilters,
    appliedVolumeTagFilters,
    appliedInstanceFilters,
  ]);

  const resetPendingFilters = () => {
    setPendingAutoscaleState([]);
    setPendingClusterNameFilters([]);
    setPendingVolumeIdFilters([]);
    setPendingVolumeTagFilters([]);
    setPendingInstanceFilters([]);
  };

  return {
    pendingAutoscaleState,
    setPendingAutoscaleState,
    pendingClusterNameFilters,
    setPendingClusterNameFilters,
    pendingVolumeIdFilters,
    setPendingVolumeIdFilters,
    pendingVolumeTagFilters,
    setPendingVolumeTagFilters,
    pendingInstanceFilters,
    setPendingInstanceFilters,
    resetPendingFilters,
  };
}
